// Vue
import { reactive, Ref, ref } from 'vue'

// Types
import type { IConstructedRegionCountry } from '../classes/RegionData'
import type { ICountry } from '../classes/StationData'
import type { IDomain } from '../classes/DomainData'

// utils
import { uuidv4 } from "../utils/uuidv4"

export class AutocompleteState {
    regions: IConstructedRegionCountry[] = []
    domains: IDomain[] = []
    stations: ICountry[] = []
    accommodations: any[] = []
    isDropdownOpen: boolean = false
    showTopStations: boolean = true
    madeAccommodationsRequest: boolean = false
    inputValue: string = ''
}

export const createAutocompleteState = (id: string): AutocompleteState => {
    const newState = reactive(new AutocompleteState())
    autocompleteState[id] = newState
    return newState
}

export const getAutocompleteState = (givenID = ""): { state: AutocompleteState, id: string } => {
    const id = autoCompleteStateId.value || givenID || uuidv4()
    const state: AutocompleteState | undefined = autocompleteState[id]
    if (!state) {
        const id = givenID || uuidv4()
        const state = createAutocompleteState(id)
        return reactive({ state, id })
    }
    return reactive({ state, id })
}

export const autoCompleteStateId: Ref<string> = ref("")

const autocompleteState: { [id: string]: AutocompleteState } = reactive({})

export default autocompleteState